// extracted by mini-css-extract-plugin
export default {"wrapper":"SiteGraphicItem_wrapper__cfKz-","wrapperActive":"SiteGraphicItem_wrapperActive__rg7gd","text":"SiteGraphicItem_text__2BR44"};